import { ModalActionTypes } from '@acorns/web-components'
import { domainMap } from 'config/env'

import getDefaultEventData from 'components/Trackers/defaults'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import trackEvent from 'utils/analytics/trackEvent'

export const generateErrorCodeMap = ({ env, ...props }, values) => {
  const map = new Map()
  map.set('email_has_already_been_taken', {
    title: 'Do you already have an account?',
    message: 'Looks like an account with this email address already exists. Tap below to log in.',
    actions: [
      {
        type: ModalActionTypes.secondary,
        label: 'Go Back',
        handler: props.closeErrorModal,
      },
      {
        type: ModalActionTypes.primary,
        label: 'Login',
        handler: () => {
          trackEvent('Button Tapped', {
            eventData: {
              object_name: TRACKER_IDS.SIGNUP.EMAIL_EXISTS_REDIRECT_BUTTON,
              screen: 'registrationCreateAccount',
              screen_name: 'registrationCreateAccount',
              cta_title: 'Login',
              ...getDefaultEventData('Button Tapped'),
            },
            flow: props.isProspectOnDirectToMobile ? 'directToMobile' : props.flow,
            partner: props.partner,
          })

          if (props.partner && props.partner.org.accountExistsRedirectUrl) {
            window.location.assign(props.partner.org.accountExistsRedirectUrl)
          }

          const email = values?.email

          document.cookie = `emailToPrefill=${email}; domain=${domainMap.get(
            env.get('buildEnv'),
          )};max-age=3600`
          window.location.replace(env.get('loginUrl'))
        },
      },
    ],
  })
  map.set('verification_failed', {
    title: 'Recaptcha errors',
    message:
      'The recaptcha security check failed, so we’re unable to complete your account at this time. This is for your security, and you can try again.',
    actions: [
      {
        label: 'OK',
        handler: props.closeErrorModal,
      },
    ],
  })

  return map
}
